import React, {Component} from 'react';
import config from 'config'

class RevLoan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: false,
            id: "",
            text: "",
            userdetail: {},
            todaydate: null,
            contractdate: null
        }
        this.agreeCheck = this.agreeCheck.bind(this);
        this.getValue = this.getValue.bind(this);

    }

    getValue(id) {
        fetch(`${config.REV_URL}/revloans/${id}`, {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((result) => {
                console.log('Success:', result.message);

                if (result && result.loan && result.loan.agreeduser) {
                    let lk = window.location.href.replace("rl", "rll");
                    window.location.replace(lk);
                    this.setState({hide: true})
                } else {
                    this.setState({hide: true})
                }
                let mylimit = 0;
                if (result && result.loan && result.loan.requestsamount && result.loan.requestsamount.length > 0) {
                    let rra = result.loan.requestsamount.map(i => i.selectedlimit).reduce((a, b) => a + b, 0)
                    mylimit = result.loan.currentlimit - rra;
                } else {
                    mylimit = result.loan.currentlimit;
                }
                let objuserdeatails = {name: result.loan.name, limit: mylimit};
                this.setState({
                    id: result.loan._id,
                    todaydate: result.loan.todaydate,
                    loanIdnew: result.loan.loanIdnew,
                    contractdate: result.loan.contracttime,
                    userdetail: objuserdeatails
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    agreeCheck() {
        if (this.state && this.state.userdetail && this.state.userdetail.limit && this.state.userdetail.limit > 0) {
            fetch(`${config.REV_URL}/revloans/${this.state.id}`, {
                method: 'PUT',
                body: {}
            })
                .then((response) => response.json())
                .then((result) => {
                    console.log('Success:', result.message);
                    //this.setState({text: result})
                    window.location.replace(window.location.origin);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }


    componentDidMount() {
        console.log("hjds",)
        this.getValue(this.props.match.params.id);
    }

    render() {
        return (
            <div>
                {this.state.hide && <div className="mainGridW">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="enterPa">
                                    <h3 className="newFontB">Revloan Agreement</h3>
                                    <div className="sater">

                                        <p>Date : {this.state.todaydate}</p>
                                        <p>Customer Name : {this.state.userdetail.name}</p>


                                        <div className="newPara">
                                            <br></br>
                                            <p><b>Dear Sir / Madam,</b></p>

                                            <p>
                                                <h6>SUB: LOAN AGREEMENT {this.state.loanIdnew} </h6>
                                            </p>
                                            <p>
                                                <ol>
                                                    <li style={{'list-style': 'devanagari'}}> It is matter of record
                                                        that you have availed the above-mentioned loan.
                                                    </li>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> In view of you being an
                                                        esteemed client and customer (as on date of issue of this
                                                        letter) of our company, that in addition to the amount disbursed
                                                        in your favour as per the above mentioned loan account, our
                                                        company is pleased to offer a revolving loan / overdraft loan
                                                        facility for the sum of Rs. {this.state.userdetail.limit} in
                                                        your favour.
                                                    </li>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> The terms and conditions
                                                        of the revolving loan have already been mentioned in the loan
                                                        agreement dated {this.state.contractdate} executed between you
                                                        and company (the contents of same are not being repeated because
                                                        of brevity), some of which are mentioned below for your
                                                        information;
                                                    </li>
                                                    <br/>
                                                    <div>
                                                        <ol>
                                                            <li style={{'list-style': 'lower-alpha'}}>) Payment of usage
                                                                charges by you as defined and explained in para 2 of the
                                                                loan agreement.
                                                            </li>
                                                            <br/>
                                                            <li style={{'list-style': 'lower-alpha'}}>) Payment of
                                                                interest by you as defined and explained in para 3 of
                                                                the loan agreement.
                                                            </li>
                                                            <br/>
                                                            <li style={{'list-style': 'lower-alpha'}}>) Payment of
                                                                processing fee by you as defined and explained in para 4
                                                                of the loan agreement.
                                                            </li>
                                                        </ol>
                                                    </div>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> You shall be entitled to
                                                        use the revolving loan / overdraft facility towards the payment
                                                        of EMI, other due amounts payable by you towards the Original
                                                        Sanctioned loan account no: {this.state.loanIdnew}.
                                                    </li>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> This is only letter of
                                                        offer and is not legally binding upon the company in any manner
                                                        what so ever and the company shall not be bound to disburse the
                                                        additional loan facility unless compliance of statutory
                                                        requirements by the company.
                                                    </li>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> Sanction and subsequent
                                                        disbursement of the revolving loan / over draft facility shall
                                                        be considered only on receipt of formal acknowledgement and
                                                        confirmation from you of this letter of offer.
                                                    </li>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> The company reserves its
                                                        rights to change / modify / withdraw the revolving loan /
                                                        overdraft facility offer / conditions at any time prior to
                                                        disbursement of the said facility in your favour. In such
                                                        circumstances, the company shall not be obliged to give any
                                                        prior intimation etc.
                                                    </li>
                                                    <br/>
                                                    <li style={{'list-style': 'devanagari'}}> This revolving loan /
                                                        overdraft facility shall be subject to compliance of terms and
                                                        conditions of the loan agreement dated {this.state.todaydate} by
                                                        you.
                                                    </li>
                                                </ol>
                                            </p>
                                            <p>Regards,</p>
                                            <p>
                                                <img
                                                    src="https://revfin-dev.s3.ap-south-1.amazonaws.com/sameeraggarwal-1.png"
                                                    alt='' width="120" height="50"/>
                                            </p>
                                            <p>Sameer Aggarwal</p>
                                            <br/>
                                            Director, Aristo Securities Private Limited
                                            <br/>
                                            <br/>
                                            <br/>
                                            <p>By clicking “I Agree”, you hereby agree to have read the contents of the
                                                above letter of offer and after reading and understanding the contents
                                                of the same, hereby willfully without any force, coercion, and undue
                                                influence request the company to sanction and disburse revolving loan /
                                                overdraft facility in your favour.</p>
                                            <div>
                                                <button className="colorVbtn" onClick={() => this.agreeCheck()}> I
                                                    Agree
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}


export default RevLoan



// WEBPACK FOOTER //
// ./src/components/RevLoan.js